import BaseLayoutView from 'app/src/views/base/BaseLayoutView';
import paymentViewTemplate from './templates/detail-view.hbs';

// configure
let View = BaseLayoutView.extend({
  template: paymentViewTemplate,
  regions: {
    header: '.action-row',
    content: '.table-less',
  },

  ui: {
    buttonArea: '#detail_buttons',
    disableShade: '.detail-view-shade',
  },
});

// define
export default class DetailView extends View {
  /**
   * Adds a button to the view
   *
   * @param {jQuery.Object} button    The button
   */
  addButton(button) {
    if (this.header.currentView) {
      this.header.currentView.addButton(button);
    }
  }

  /**
   * Creates a disabled affect for the entire details section of the view.
   *
   * @param {Boolean} disable     When true, the details section will be greyed out and disabled
   */
  disableDetailView(disable) {
    this.ui.disableShade.toggleClass('hidden', !disable);
  }
}
